import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules'

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Vue.use(VueToast);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })
  return formatter.format(value)
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
